import Dialog from './Dialog.js';

class AlreadyActivatedDialog extends Dialog {
    static create(params) {
        return new AlreadyActivatedDialog(params);
    }

    constructor({id}) {
        super({id});

        this.find('.ok-button').click(() => this.hide());
    }
}

export default AlreadyActivatedDialog;